const Constant = {
    // Default Image
    AVATAR_IMAGE: "https://ot360dev.azureedge.net/master/avatar-img.jpg",
  };
  
  export default Constant;
  